module.exports = __webpack_public_path__ + "static/media/calendar.90e53680.svg";